///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.fieldLib = abcsetup.fieldLib || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.fieldLib.attrs = [];
abcsetup.fieldLib.fields = [];


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    abcsetup.fieldLib.attrs = ['showIf', 'hideIf', 'disabledIf', 'requiredIf', 'readonlyIf', 'autoCompleteFrom'];

    abcsetup.fieldLib.init();
    //abcsetup.loadRouteJS('fieldsInit');

    // Create an observer instance to watch for new elements being added to the DOM.
    new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        abcsetup.fieldLib._applyCustomAttrs($(node));
                    }
                });
            }
        }
    }).observe(document.body, { childList: true, subtree: true });
});


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.fieldLib = {
    init: function (parent = $('body')) {
        abcsetup.fieldLib.fields = [];
        $(".numeric_only").forceNumeric();
        $(".numeric_time").forceNumericTime();
        $(":input.numeric_extended, :input.numeric, :input[type=number]").forceNumericExtended();

        // Apply maxlength field validate rule to all fields that have a maxlength specified
        $(':input[maxlength]', parent).each(function () {
            let rules = $(this).attr('fieldValidate');
            $(this).attr('fieldValidate', rules ? rules + '|maxLength' : 'maxLength');
        });

        // Apply minlength field validate rule to all fields that have a minlength specified
        $(':input[minlength]', parent).each(function () {
            let rules = $(this).attr('fieldValidate');
            $(this).attr('fieldValidate', rules ? rules + '|minLength' : 'minLength');
        });

        // Find all elements that have a mask attribute
        parent.find('*[mask]').each(function () {
            var mask = $(this).attr('mask');
            $(this).mask(mask, {placeholder: mask.replace(/0/g, '_')});
        });

        // Apply any current masks
        parent.find('input.currency').mask('###0.00', {reverse: true});

        // Apply any shuttlebox -------------------------------------------------------------------
        $('select.shuttlebox-right').each(function () {
            var select_right = $(this);
            var this_shuttlebox = select_right.closest("div.shuttlebox");
            var select_left = this_shuttlebox.find("select.shuttlebox-left");

            this_shuttlebox.on("click", ".shuttlebox-add", function() {
                select_left.find("option:selected").remove().appendTo(select_right);
                select_right.find("option").prop("selected", "selected");
                select_right.trigger("change");
            });
            this_shuttlebox.on("click", ".shuttlebox-remove", function() {
                select_right.find("option:selected").remove().appendTo(select_left);
                select_right.find("option").prop("selected", "selected");
                select_right.trigger("change");
            });

            this_shuttlebox.on('dblclick', "select.shuttlebox-left option", function () {
                select_left.find("option:selected").remove().appendTo(select_right);
                select_right.find("option").prop("selected", "selected");
                select_right.trigger("change");
            });
            this_shuttlebox.on('dblclick', "select.shuttlebox-right option", function () {
                select_right.find("option:selected").remove().appendTo(select_left);
                select_right.find("option").prop("selected", "selected");
                select_right.trigger("change");
            });
        });
        // ----------------------------------------------------------------------------------------

        // Apply date field with placeholder
        parent.find('input.date-placeholder').each(function () {
            $(this).focus(function () {
                this.type = 'date';
            }).blur(function () {
                if ($(this).val() == '') this.type = 'text';
            }).change(function () {
                if ($(this).val() == '') this.type = 'text';
            });

            if ($(this).val() != '') this.type = 'date';
        });

        // Apply read-only attributes to any select drop downs
        parent.find('select[readonly]').each(function () {
            $(this).bind('change', function () {
                if ($(this).attr('readonly')) {
                    abcsetup.fieldLib._readOnlyField($(this));
                } else {
                    abcsetup.fieldLib._readOnlyField($(this), false);
                }
            });

            abcsetup.fieldLib._readOnlyField($(this));
        });

        // Apply custom attributes
        this._applyCustomAttrs(parent);

        // Apply auto complete functionality
        this.autoComplete(parent);

        // Call the page specified fieldsInit function
        abcsetup.loadRouteJS('fieldsInit');
    },

    /**
     * Apply custom attributes
     */
    _applyCustomAttrs(parent) {
        // Loop through all the custom field attrs
        $(abcsetup.fieldLib.attrs).each(function () {
            var _attr = this;

            // Find all elements that the current attribute
            parent.find('*[' + _attr + ']').each(function () {
                abcsetup.fieldLib.bindElement($(this), _attr);
            });
        });
    },


    /**
     * Apply auto complete functionality
     *
     * @param {*} parent
     */
    autoComplete: function (parent) {
        // Apply autocomplete fields
        parent.find('input[data-autocomplete]').each(function () {
            var current_val = $(this).val() ? $(this).val().split('|') : String($(this).data('autocomplete-value')).split('|');
            $(this).val('');

            var route = null;

            if ($(this).data('autocomplete') == 'brokers') {
                route = '/api/thoughtspot/autocomplete/brokers';
            } else {
                route = '/api/autocomplete/' + $(this).data('autocomplete');
            }

            var new_field = $(this).clone();

            $(this).attr('type', 'hidden');
            new_field.data('autocomplete-target', $(this));
            new_field.attr('id', 'autocomplete_' + (new_field.attr('id') ? new_field.attr('id') : new_field.attr('name'))).attr('name', '');
            $(this).after(new_field);

            // Set the hidden field values
            if (current_val.length > 1) {
                new_field.val(current_val[1]);
                $(this).val(current_val[0]);
            } else {
                new_field.val(current_val);
                $(this).val(current_val);
            }

            new_field.autoComplete({
                minLength: 1,
                resolverSettings: {
                    url: route,
                    fail: function() {
                        //console.log('error');
                    }
                }
            }).attr("autocomplete", "off");

            // Autocomplete value selected
            new_field.on('autocomplete.select', function (evt, item) {
                $(this).data('autocomplete-target').val(item.value).trigger('change');
                abcsetup.loadRouteJS('autoCompleteSelected');
            }).on('change', function () {
                if ($(this).val() == '') {
                    $(this).data('autocomplete-target').val('');
                }
            }).on('autocomplete.freevalue', function (evt, value) {
                abcsetup.loadRouteJS('autoCompleteFreevalue');
            });
        });
    },


    /**
     * Match the start of the values in a select2 search
     *
     * @param {*} params
     * @param {*} data
     */
    _select2Matcher: function (params, data) {
        data.parentText = data.parentText || "";

        // Always return the object if there is nothing to compare
        if ($.trim(params.term) === '') {
            return data;
        }

        // Do a recursive check for options with children
        if (data.children && data.children.length > 0) {
            // Clone the data object if there are children
            // This is required as we modify the object to remove any non-matches
            var match = $.extend(true, {}, data);

            // Check each child of the option
            for (var c = data.children.length - 1; c >= 0; c--) {
                var child = data.children[c];
                child.parentText += data.parentText + " " + data.text;

                var matches = abcsetup.fieldLib._select2Matcher(params, child);

                // If there wasn't a match, remove the object in the array
                if (matches == null) {
                    match.children.splice(c, 1);
                }
            }

            // If any children matched, return the new object
            if (match.children.length > 0) {
                return match;
            }

            // If there were no matching children, check just the plain object
            return abcsetup.fieldLib._select2Matcher(params, match);
        }

        // If the typed-in term matches the text of this term, or the text from any parent term, then it's a match.
        var original = (data.parentText + ' ' + data.text).toUpperCase().trim();
        var term = params.term.toUpperCase().trim();

        // We're using startMatch - so only match the start of each val
        if ($(data.element).parent().data('match-custom') == 'startMatch') {
            if (original.indexOf(term) == 0) {
                return data;
            }

            // Check if the text contains the term
        } else if (original.indexOf(term) > -1) {
            return data;
        }

        // If it doesn't contain the term, don't return anything
        return null;
    },


    /**
     *
     * @param {*} elem
     * @param {*} _attr
     */
    bindElement(elem, _attr) {
        $(elem).each(function () {
            // Format the element's rule for the specified attr
            abcsetup.fieldLib.formatRules($(this), _attr)

            var _elem = $(this);
            var rule = _elem.attr(_attr);
            //console.log('bindElement: '+_attr, _elem);

            if (_attr == 'autoCompleteFrom') {
                rule = rule.replace("|", "!=|");
                rule = rule.replace("&", "!=&");
            }

            rule = rule.replace(/ {2}|\r\n|\n|\r/gm, "").split(/[&|]/);

            $(rule).each(function () {
                if (this) {
                    if (rule != "" && rule != " ") {
                        // Format any field attrs if needed
                        // TODO: move this to abcsetup.fieldLib.formatRules
                        if (_attr == 'autoCompleteFrom') {
                            var rule_tmp = '';
                            rule = rule + '!=';
                            rule_tmp = rule.replace(",","|");
                            rule_tmp = rule.replace(",","&");
                            rule_tmp = rule_tmp.replace("!=!=","!=");
                            _elem.attr(_attr, rule_tmp);
                        }

                        abcsetup.fieldLib.applyRules(_attr, _elem, this);
                    }
                }
            });

        });
    },

    /**
     * Format the element's rule for the specified attr
     *
     * @param {*} attr
     * @param {*} elem
     */
    formatRules(elem, attr) {
        var rules = elem.attr(attr).replace(/ {2}|\r\n|\n|\r/gm, "").split(/[&|]/);

        $(rules).each(function () {
            var operator = abcsetup.fieldLib._findOperator(this);
            var id = abcsetup.fieldLib._cleanValue(this.split(operator)[0]);

            // Apply logistical rules
            if (id.indexOf('closest:') == 0) {
                if (elem.closest('.form-div').length) {
                    var new_id = id.replace('closest:', '');
                    new_id = elem.closest('.form-div').find(new_id).attr('id');
                    elem.attr(attr, elem.attr(attr).replace(id, new_id));

                } else {
                    console.error('Invalid rule: ' + this);
                    elem.attr(attr, elem.attr(attr).replace(this, ''));
                }
            }

            if (id.indexOf('checkbox:') == 0) {
                var new_id = id.replace('checkbox:', '');
                value = new_id.split('[')[1].replace(']','');
                new_id = new_id.split('[')[0];

                // We have just 1 checkbox + value combo
                if ($('input[name="' + new_id + '[]"][value="' + value + '"]').length == 1) {
                    var checkboxId = $('input[name="' + new_id + '[]"][value="' + value + '"]').data('new_id') || abcsetup.randomString();
                    // Keep track of our new id to use in other rule/conditions
                    $('input[name="' + new_id + '[]"][value="' + value + '"]').attr('id', checkboxId).data('new_id', checkboxId);;
                    elem.attr(attr, elem.attr(attr).replace(id, checkboxId));

                } else {
                    console.error('Invalid rule: ' + this);
                    elem.attr(attr, elem.attr(attr).replace(this, ''));
                }
            }

            // Check if all the specified selectors are empty
            if (id.indexOf('groupEmpty:') == 0) {
                if (elem.closest('.form-div').length) {
                    var selector = id.replace('groupEmpty:', '');
                    var new_id = '';

                    elem.closest('.form-div').find(selector).each(function() {
                        new_id = new_id + $(this).attr('id') + '=&';
                    });

                    // Remove the last ampersand
                    if (new_id) {
                        new_id = new_id.substring(0, new_id.length - 1);
                    }

                    elem.attr(attr, elem.attr(attr).replace(id, new_id));

                } else {
                    console.error('Invalid rule: ' + this);
                    elem.attr(attr, elem.attr(attr).replace(this, ''));
                }
            }
        });
    },


    /**
     * Bind the specific element's visibility based on the specified fieldLib rule
     *
     * @param {*} attr
     * @param {*} elem
     * @param {*} rule
     */
    applyRules(attr, elem, rule) {
        const operator = abcsetup.fieldLib._findOperator(rule);
        const id = abcsetup.fieldLib._cleanValue(rule.split(operator)[0]);

        // There's an undefined rule
        if (id === undefined || id === '') {
            return;
        }

        // Create an array for the target's rules
        if (abcsetup.fieldLib.fields === undefined) {
            abcsetup.fieldLib.fields = [];
        }

        if (abcsetup.fieldLib.fields[id] === undefined) {
            abcsetup.fieldLib.fields[id] = [];
        }

        // Add the field rule to the target
        abcsetup.fieldLib.fields[id].push({
            attr: attr,
            elem: elem,
        });

        // Bind the field only once
        $('#' + id).unbind('change.fieldLib').bind('change.fieldLib', function () {
            Promise.all(
                // Loop through the rules for the current field
                (abcsetup.fieldLib.fields[id] || []).map(item =>
                    // Check the rules for the specified elem
                    abcsetup.fieldLib._enforceRule(item.attr, item.elem)
                )
            ).then(() => {
                // Apply any existing child rules
                abcsetup.fieldLib._applyChildRules(attr, elem, rule);
            });
        }).trigger('change');

        // The field isn't found, treat it as just an internal rule
        if ($('#' + id).length == 0) {
            Promise.all([
                // Check the rules for the specified elem
                abcsetup.fieldLib._enforceRule(attr, elem)
            ]).then(() => {
                // Apply any existing child rules
                abcsetup.fieldLib._applyChildRules(attr, elem, rule);
            });
        }
    },


    /**
     * Check the rules for the specified elem
     *
     * @param {*} attr
     * @param {*} elem
     * @returns {Promise<void>}
     * @private
     */
    _enforceRule(attr, elem) {
        // TODO: To allow for async rules, we'll probably want to make this an async function and then await the _checkRules call after that one is an async function too.
        const result = abcsetup.fieldLib._checkRules(attr, elem);

        if (window.abcsetup.fieldLib[attr]) {
            window.abcsetup.fieldLib[attr](elem, result);
        }

        return Promise.resolve();
    },


    /**
     * Check the rules for the specified elem
     */
    _checkRules(attr, elem) {
        let rule = elem.attr(attr);
        const orig = rule; // This looks to be for debugging only.

        if (!rule) {
            return true;
        }

        $(elem.attr(attr).split(/[&|]/)).each(function (i) {
            var value;
            if (this != '') {
                var tmpVal = this;
                var operator = abcsetup.fieldLib._findOperator(tmpVal);
                var field = abcsetup.fieldLib._cleanValue(tmpVal.split(operator)[0]);
                var val = abcsetup.fieldLib._cleanValue(tmpVal.split(operator)[1]);

                if ($('#' + field).length) {
                    if($('#' + field).is(':radio')) {
                        value = $('#' + field + ':checked').val();
                    } else {
                        value = (!$('#' + field).is(':checkbox') || $('#' + field).prop('checked'))
                            ? $('#' + field).val()
                            : '';
                    }

                    // Clean the value of the input field
                    if (typeof value == 'string') {
                        value = abcsetup.fieldLib._cleanValue(value);
                    }

                } else {
                    value = abcsetup.fieldLib._formatValue(field);
                }

                var find = field + operator + val;
                if (String(operator) === '=') operator = '==';

                // We have a value carried along
                if (val.indexOf(':') > -1) {
                    val = val.split(':')[0];
                }

                //alert(find + '\n' + "'" + value + "'" + operator + "'" + val + "'");

                // The below operator is used when the val needs to be formated through
                // the _formatValue function.
                if (operator == '<$') {
                    val = abcsetup.fieldLib._formatValue(val);
                    if (value && val) {
                        // Numerically compares value and val.
                        rule= `${value} < ${val}`;
                    } else {
                        // Operators cant evaluate null operands.
                        // If value or val is not provided then set rule
                        // to a condition which is false so that the field is not shown.
                        rule = '1 < 0';
                    }
                } else if (operator == '*=') {
                    rule = rule.replace(find, "'" + value + "'.includes('" + val + "')");
                } else {
                    rule = rule.replace(find, "'" + value + "'" + operator + "'" + val + "'");
                }
            }
        })

        rule = rule.replace(/'&'/g, "'&&'");
        rule = rule.replace(/'\|'/g, "'||'");
        rule = rule.replace(/ {2}|\r\n|\n|\r/gm, "");
        //alert(rule);

        try {
            var result = eval(rule);
        } catch (e) {
            console.error('Invalid rule: ' + rule);
            var result = false;
        }

        // Inherit and eval showIf rules from parent elements
        if (result && elem.parent().closest('[showIf]').length > 0) {
            //console.log(orig + ': inherit rule: ' + elem.parent().closest('[showIf]').attr('showIf'));
            result = abcsetup.fieldLib._checkRules('showIf', elem.parent().closest('[showIf]'));
        }

        return result;
    },


    /**
     * Apply any existing child rules
     */
    _applyChildRules(attr, elem, rule) {
        // Apply child rules
        $(abcsetup.fieldLib.attrs).each(function () {
            var _attr = this;
            if (this && this != 'autoCompleteFrom') {
                if (elem.find('[' + this + ']').length) {
                    //console.log(rule + ': apply child rules: ' + this + ' [' + elem.find('[' + this + ']').length + ']');

                    $(elem.find('[' + this + ']')).each(function () {
                        abcsetup.fieldLib._enforceRule(_attr, $(this), null);
                    });
                }
            }
        });
    },


    /**
     * Find the operator used in the specified rule
     *
     * @param {*} rule
     */
    _findOperator(rule) {
        var operators = ['===', '==', '=', '!==', '!=', '>=', '<=', '>', '<', '*=','<$'];
        var found = null;

        $(operators).each(function () {
            if (rule.indexOf(this) > -1) {
                found = this;
            }
        });

        return found;
    },


    /**
     * Format the specified value and replace any existing variables
     *
     * @param {*} value
     */
    _formatValue(value) {
        abcsetup.item = abcsetup.item || {};

        var current_task = (abcsetup.task) ? abcsetup.task.task : '';
        var init_role = (abcsetup.item.role) ? abcsetup.item.role.class : '';
        var specialty_role = (abcsetup.item.role) ? abcsetup.item.role.role_class.specialty : '';
        var user_class = (abcsetup.userRole) ? abcsetup.userRole.class : '';
        var user_specialty = (abcsetup.user) ? abcsetup.user.specialty_role : '';
        var promo_type = (abcsetup.item.promo) ? abcsetup.item.promo.type : (abcsetup.item.type ? abcsetup.item.type : '');

        var alcohol_perc_sel = 'N';
        var json_len = (abcsetup.userOrg) ? abcsetup.userOrg.org_attribute.length : '';

        if (json_len > 0) {
            $(abcsetup.userOrg.org_attribute).each(function () {
                if (this.alcohol_perc_select && this.alcohol_perc_select == 'Y') {
                    alcohol_perc_sel = 'Y';
                }
            });
        }

        value = value.replace('_CURRENT_TASK_', current_task);
        value = value.replace('_INIT_CLASS_', init_role);
        value = value.replace('_INIT_SPECIALTY_ROLE_', specialty_role);
        value = value.replace('_USER_CLASS_', user_class);
        value = value.replace('_USER_ROLE_', user_class);
        value = value.replace('_SPECIALTY_ROLE_', user_specialty);
        value = value.replace('_ALCOHOL_PERC_SEL_', alcohol_perc_sel);
        value = value.replace('_PROMO_TYPE_', promo_type);

        // FIXME: _ITEM_OBJECT_ should not be needed as all item vars are created as hidden fields
        if (typeof value == 'string' && value.search('_ITEM_OBJECT_') > -1) {
            value = abcsetup.item[value.replace('_ITEM_OBJECT_.', '')] + '';
            // Remove parenthesis and single quotes from value
            value = value.replace(/[()]/g,'').replace(/[']/g, "");
        }

        // Searches for '_ABC_ITEM_PRICING_Z3_10_PERC_' string,
        // If found and there is a relationship between the promo_item and
        // the abc_item_pricing (through the abc_item),
        // then set the value to 10% of the z3_price price.
        if (typeof value == 'string' && value.search('_ABC_ITEM_PRICING_Z3_10_PERC_') > -1) {
            if (!abcsetup.item.a_b_c_item.pricing) {
                value = null;
            } else {
                value = abcsetup.item.a_b_c_item.pricing.z3_price*0.1;
            }
        }

        //alert(init_role);

        return value;
    },


    /**
     * Clean out the specific field - removed unwanted spaces and characters
     *
     * @param {*} field
     */
    _cleanValue(field) {
        if (field) {
            field = field.replace(/"/g, "").replace(/'/g, "").replace(/\(|\)/g, "").trim();
        }

        return field;
    },


    /**
     * Make the specified field(s) readonly or not
     * @param {*} fields
     */
    _readOnlyField(fields, readonly = true) {
        if (readonly) {
            $(fields).each(function () {
                if ($(this).prop('nodeName') == 'SELECT') {
                    // Remove any field facade we have set up already
                    if ($(this).data('select-uid')) {
                        $('[data-readonly-uid="' + $(this).data('select-uid') + '"]').remove();
                    }

                    // Generate a random id to track the field facade and hidden select field
                    var tmpID = abcsetup.randomString();
                    $(this).data('select-uid', tmpID).hide();
                    $(this).after('<input type="text" class="' + $(this).attr('class') + '" readonly data-readonly-uid="' + tmpID + '" value="' + $(this).find('option:selected').text() + '">');

                } else {
                    // Just a normal field that supports the readonly attribute
                    $(this).attr('readonly', true);
                }
            });

        } else {
            $(fields).each(function () {
                if ($(this).prop('nodeName') == 'SELECT') {
                    // Remove the field facade and show the original select field
                    $('[data-readonly-uid="' + $(this).data('select-uid') + '"]').remove();
                    $(this).data('select-uid', null).show();

                } else {
                    // Just a normal field that supports the readonly attribute
                    $(this).attr('readonly', false);
                }
            });
        }
    },


    /**
     * Use showIf attributes similar to Vue v-if
     *
     * @param {*} elem
     * @param {*} result
     */
    showIf: function (elem, result) {
        if (result) {
            // Format attachment buttons
            if (elem.hasClass('btn-attachment') && elem.data('autoappend')) {
                if ($('input[data-idx="' + elem.attr('id') + '"]').val() != '') {
                    return false;
                }
            }

            elem.show().removeClass('showIfHide');

            // Move the min length attr if needed
            if (elem.data('min')) {
                elem.attr('min', elem.data('min'));
            }
            elem.find('input').each(function () { if ($(this).data('min')) $(this).attr('min', $(this).data('min')); });

            // Move the requied attr
            if (elem.hasClass('set-required')) {
                elem.attr('required', true).removeClass('set-required');
            }

            // Move the disabled attr
            if (elem.hasClass('remove-disabled')) {
                elem.attr('disabled', false).removeClass('remove-disabled');
            }

            elem.find('.set-required').attr('required', true).removeClass('set-required');

            // Move the name attr
            if (elem.hasClass('set-name')) {
                elem.attr('name', elem.data('name')).removeClass('set-name');
            }

            elem.find('.set-name').each(function () {
                $(this).attr('name', $(this).data('name')).removeClass('set-name');
            });

            if (elem.prop('nodeName') == 'OPTION') {
                //elem.parent().val(''); // Null out the select field if we've just updated an option
            }

        } else {
            elem.hide().addClass('showIfHide');

            // Move the requied attr
            if (elem.attr('required')) {
                elem.attr('required', false).addClass('set-required');
            }

            elem.find('input:required, select:required, textarea:required, radio:required').attr('required', false).addClass('set-required');

            // Move the min length attr if needed
            if (elem.attr('min')) {
                elem.data('min', elem.attr('min')).removeAttr('min');
            }
            elem.find('input').each(function () { if ($(this).attr('min')) $(this).data('min', $(this).attr('min')).removeAttr('min'); });

            // Move the name attr
            elem.each(function () {
                $(this).data('name', $(this).attr('name')).attr('name', null).addClass('set-name');
            });

            elem.find(':input').each(function () {
                $(this).data('name', $(this).attr('name')).attr('name', null).addClass('set-name');
            });

            if (elem.prop('nodeName') == 'OPTION') {
                //elem.parent().val(''); // Null out the select field if we've just updated an option
            }
        }
    },


    /**
     * Use hideIf attributes similar to Vue v-if
     *
     * @param {*} elem
     * @param {*} result
     */
    hideIf: function (elem, result) {
        if (!result) {
            elem.show();

            // Move the requied attr
            elem.find('.set-required').attr('required', true);

            // Move the name attr
            if (elem.hasClass('set-name')) {
                elem.attr('name', elem.data('name'));
            }

            elem.find('.set-name').each(function () {
                $(this).attr('name', $(this).data('name'));
            })

            if (elem.prop('nodeName') == 'OPTION') {
                //elem.parent().val(''); // Null out the select field if we've just updated an option
            }

        } else {
            elem.hide();

            // Move the requied attr
            elem.find('input:required, select:required, textarea:required, radio:required').attr('required', false).addClass('set-required');

            // Move the name attr
            elem.data('name', $(this).attr('name')).attr('name', null).addClass('set-name');
            elem.find(':input').each(function () {
                $(this).data('name', $(this).attr('name')).attr('name', null).addClass('set-name');
            });

            if (elem.prop('nodeName') == 'OPTION') {
                //elem.parent().val(''); // Null out the select field if we've just updated an option
            }
        }
    },


    /**
     * Use disabledIf attributes similar to Vue v-if
     *
     * @param {*} elem
     * @param {*} result
     */
    disabledIf: function (elem, result) {
        if (result) {
            if (elem.prop('nodeName') == 'DIV') {
                elem.addClass('disabled').find(':input').attr('disabled', true); // Make all child fields disabled
                // If a field is disabled, we don't want any input data coming back in the request variable.
                // elem.after('<input type="hidden" name="'+elem.attr("name")+'" value="'+elem.val()+'">');
            } else {
                elem.attr('disabled', true); // Assume the elem is a form field
                // elem.after('<input type="hidden" name="'+elem.attr("name")+'" value="'+elem.val()+'">');
            }

        } else {
            if (elem.prop('nodeName') == 'DIV') {
                elem.removeClass('disabled').find(':input').attr('disabled', false); // Make all child fields not disabled
                // $("input[name='"+elem.attr("name")+"']").remove();
            } else {
                elem.attr('disabled', false); // Assume the elem is a form field
                // $("input[name='"+elem.attr("name")+"']").remove();
            }
        }
    },

    /**
     * Use readonlyIf attributes similar to Vue v-if
     *
     * @param {*} elem
     * @param {*} result
     */
    readonlyIf: function (elem, result) {
        if (result) {
            if (elem.prop('nodeName') == 'DIV') {
                elem = elem.find(':input');
            }

            this._readOnlyField($(elem), true);

        } else {
            if (elem.prop('nodeName') == 'DIV') {
                elem = elem.find(':input');
            }

            this._readOnlyField($(elem), false);
        }
    },


    /**
     * Use requiredIf attributes similar to Vue v-if
     *
     * @param {*} elem
     * @param {*} result
     */
    requiredIf: function (elem, result) {
        if (result) {
            if (elem.prop('nodeName') == 'DIV') {
                elem.addClass('required').find(':input').not('.shuttlebox-left, .set-required, .showIfHide, .confidential').attr('required', true); // Make all child fields required
            } else {
                if (!elem.hasClass('showIfHide') && !elem.hasClass('set-required')) {
                    elem.attr('required', true); // Assume the elem is a form field
                }
            }

        } else {
            if (elem.prop('nodeName') == 'DIV') {
                elem.removeClass('required').find(':input').not('.shuttlebox-left, .set-required, .showIfHide, .confidential').attr('required', false); // Make all child fields not required
                fieldValidate.removeOrnaments(elem);
            } else {
                if (!elem.hasClass('showIfHide') && !elem.hasClass('set-required')) {
                    elem.attr('required', false); // Assume the elem is a form field
                    fieldValidate.removeOrnaments(elem);
                }
            }
        }
    },


    /**
     *
     * @param {*} elem
     * @param {*} result
     */
    autoCompleteFrom: function (elem, result) {
        // Parse out the autoCompleteFrom from field
        var tmpVal = elem.attr('autoCompleteFrom');
        var operator = abcsetup.fieldLib._findOperator(tmpVal);

        var field = '';
        var field2 = '';
        // We have multiple origins - find the one with a value
        if (tmpVal.indexOf('|') > -1) {
            field = $('#' + tmpVal.split('|')[0].replace(operator, "")).val() ? tmpVal.split('|')[0].replace(operator, "") : tmpVal.split('|')[1].replace(operator, "");
        }
        else if (tmpVal.indexOf('&') > -1) {
            field = $('#' + tmpVal.split('&')[0].replace(operator, "")).val() ? tmpVal.split('&')[0].replace(operator, "") : tmpVal.split('&')[1].replace(operator, "");
            field2 = $('#' + tmpVal.split('&')[1].replace(operator, "")).val() ? tmpVal.split('&')[1].replace(operator, "") : "";
        }
        else {
            field = abcsetup.fieldLib._cleanValue(tmpVal.split(operator)[0]);
        }

        //elem.find('option').remove();

        // Set up the source field var
        sourceField = $('#' + field);

        if (field2 != "") {
            sourceField2 = $('#' + field2);
            sourceField2Val = sourceField2.val();
        }
        else {
            sourceField2 = '';
            sourceField2Val = '';
        }

        if (result) {
            if (elem.prop('nodeName') == 'DIV') {
                elem.removeClass('disabled').find(':input').attr('disabled', false).val(''); // Make all child fields not disabled
                var targetField = elem.find(':input');
            } else {
                elem.attr('disabled', false).val(''); // Assume the elem is a form field
                var targetField = elem;
            }

            // The target field has not been auto completed based on the current val
            if (targetField.data('autocomplete_val') != sourceField.val()) {
                targetField.data('autocomplete_val', sourceField.val());

                // Send off the field elem's id and the autoCompleteFrom field's id and value
                if (targetField.length && !targetField.hasClass('view-only')) {
                    //alert(targetField.attr('id') + '\n' + field + '\n' + sourceField.val());
                    if (targetField.prop('nodeName') == 'SELECT') {
                        targetField.find('option').remove();
                        targetField.append('<option value="">- select -</option>');
                    }

                    // Block the UI with a spinner to allow the AJAX call to complete before user interaction
                    abcsetup.blockUI(true);
                    axios.get('/api/autocomplete?id=' + targetField.attr('id') + '&field=' + field + '&val=' + sourceField.val() + '&val2=' + sourceField2Val).then(response => {
                        //alert(JSON.stringify(response.data));
                        // FIXME: for some reason we have to re-find sourceField?
                        sourceField = $('#' + field);

                        abcsetup.unblockUI();
                        if (response.data && response.data[0]) {
                            if (targetField.prop('nodeName') == 'SELECT') {
                                $(response.data).each(function () {
                                    targetField.append('<option value="' + this.value + '">' + this.text + '</option>');
                                });

                                if (response.data.length == 1) {
                                    targetField.find('option[value=""]').remove();
                                    targetField.val(response.data[0].value);

                                    if (sourceField.attr('targetFieldNotTriggered') == undefined) {
                                        targetField.trigger('change');
                                    }

                                    if (sourceField.attr('autoCompleteDisabled') == undefined) {
                                        //sourceField.attr('disabled', true);
                                    }

                                    // The dropdown is a disabled one - update the placeholder value
                                    if (targetField.data('select-uid')) {
                                        $('input[data-readonly-uid=' + targetField.data('select-uid') + ']').val(targetField.find('option:selected').text());
                                    }

                                    // We have more than 1 result
                                } else {
                                    // We have a value already for the target field elem
                                    if (abcsetup.item && abcsetup.item[targetField.attr('id')] && abcsetup.item[targetField.attr('id')] != '') {
                                        targetField.val(abcsetup.item[targetField.attr('id')]);

                                        if (sourceField.attr('targetFieldNotTriggered') == undefined) {
                                            targetField.trigger('change');
                                        }
                                    }
                                }

                            } else {
                                targetField.val(response.data[0].value);

                                if (sourceField.attr('targetFieldNotTriggered') == undefined) {
                                    targetField.trigger('change');
                                }
                            }

                        } else if (targetField.attr('autocomplete-error')) {
                            abcsetup.alerts.show('Error Loading Data', targetField.attr('autocomplete-error'));
                        }
                    });
                }
            }

        } else {
            if (elem.prop('nodeName') == 'DIV') {
                elem.removeClass('disabled').find(':input').attr('disabled', true).val(''); // Make all child fields not disabled
            } else {
                if (elem.attr('autoCompleteNotDisabled') != undefined) {
                    elem.attr('disabled', false).val('');
                }
                else {
                    elem.attr('disabled', true).val(''); // Assume the elem is a form field
                }
            }
        }
    },
}
